import React from "react"
import PropTypes from "prop-types"

const Marker = ({
  style = {},
  fill = "white",
  width = "100%",
  className = "map-marker",
  viewBox = "0 0 566.9 566.9"
}) => (
  <svg
    width={width}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <g>
      <path fill="none" stroke={fill} strokeWidth="30" strokeMiterlimit="10" d="M390,435.5H177V169.7c0-21.1,17.1-38.3,38.3-38.3h136.5c21.1,0,38.3,17.1,38.3,38.3V435.5z"></path>
      <line stroke={fill} strokeWidth="30" strokeLinecap="round" strokeMiterlimit="10" fill="none" x1="126" y1="435.5" x2="441" y2="435.5"></line>
      <path fill={fill} d="M255.5,211.7h-22c-3.2,0-5.8-2.6-5.8-5.8v-22c0-3.2,2.6-5.8,5.8-5.8h22c3.2,0,5.8,2.6,5.8,5.8v22  C261.3,209.1,258.7,211.7,255.5,211.7z"></path>
      <path fill={fill} d="M331.5,211.7h-22c-3.2,0-5.8-2.6-5.8-5.8v-22c0-3.2,2.6-5.8,5.8-5.8h22c3.2,0,5.8,2.6,5.8,5.8v22  C337.3,209.1,334.7,211.7,331.5,211.7z"></path>
      <path fill={fill} d="M255.5,274.5h-22c-3.2,0-5.8-2.6-5.8-5.8v-22c0-3.2,2.6-5.8,5.8-5.8h22c3.2,0,5.8,2.6,5.8,5.8v22  C261.3,271.9,258.7,274.5,255.5,274.5z"></path>
      <path fill={fill} d="M331.5,274.5h-22c-3.2,0-5.8-2.6-5.8-5.8v-22c0-3.2,2.6-5.8,5.8-5.8h22c3.2,0,5.8,2.6,5.8,5.8v22  C337.3,271.9,334.7,274.5,331.5,274.5z"></path>
      <path fill={fill} d="M255.5,337.2h-22c-3.2,0-5.8-2.6-5.8-5.8v-22c0-3.2,2.6-5.8,5.8-5.8h22c3.2,0,5.8,2.6,5.8,5.8  v22C261.3,334.6,258.7,337.2,255.5,337.2z"></path>
      <path fill={fill} d="M331.5,337.2h-22c-3.2,0-5.8-2.6-5.8-5.8v-22c0-3.2,2.6-5.8,5.8-5.8h22c3.2,0,5.8,2.6,5.8,5.8v22  C337.3,334.6,334.7,337.2,331.5,337.2z"></path>
      <path fill={fill} d="M255.5,400h-22c-3.2,0-5.8-2.6-5.8-5.8v-22c0-3.2,2.6-5.8,5.8-5.8h22c3.2,0,5.8,2.6,5.8,5.8v22  C261.3,397.4,258.7,400,255.5,400z"></path>
      <path fill={fill} d="M331.5,400h-22c-3.2,0-5.8-2.6-5.8-5.8v-22c0-3.2,2.6-5.8,5.8-5.8h22c3.2,0,5.8,2.6,5.8,5.8v22  C337.3,397.4,334.7,400,331.5,400z"></path>
    </g>
  </svg>
)

Marker.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default Marker
